export default "__VITE_ASSET__PizSKuu2__"